"use client";

import React from "react";
import { Film, Camera, Map, CircleCheck, ArrowRight, Clock, Trophy, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const servicesData = [{
  id: "01",
  title: "18-Hole Flyovers",
  description: "Professional aerial walkthroughs showcasing every hole from tee to green with cinematic visuals designed for websites, memberships, and golf marketing.",
  icon: Film
}, {
  id: "02",
  title: "Clubhouse & Course Branding",
  description: "Luxury drone video and photography highlighting clubhouses, practice facilities, amenities, and the full golf experience.",
  icon: Camera
}, {
  id: "03",
  title: "Yardage & Hazard Graphics",
  description: "Strategic aerial overlays showing hazards, carry distances, landing zones, and course visualization.",
  icon: Map
}];
const trustIndicators = [{
  label: "FAA Part 107 Certified",
  icon: ShieldCheck
}, {
  label: "Arizona Golf Specialists",
  icon: Trophy
}, {
  label: "Fast Turnaround Times",
  icon: Clock
}];
const bottomFeatures = [{
  title: "Fast Turnaround",
  description: "Quick delivery without compromising on cinematic quality."
}, {
  title: "Golf-Focused Media",
  description: "Specialized expertise in capturing the unique beauty of golf courses."
}, {
  title: "Premium Quality",
  description: "High-end 4K production tailored for luxury country clubs."
}];
export default function VisualStorytellingExpertise() {
  return <section data-section-id="234207" id="signature-media-services" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none opacity-10">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/20 rounded-lg blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-secondary/10 rounded-lg blur-[120px]" />
      </div>

      <div className="container mx-auto max-w-7xl px-6 relative z-10">
        {}
        <div className="flex flex-col lg:flex-row items-center gap-12 mb-24">
          <div className="lg:w-1/2 space-y-6">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-foreground">
              More Than Drone Footage — <br />
              <span className="text-primary">Premium Golf Course Media</span>
            </h2>
            <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">Trow Golf Media helps golf courses, country clubs, and golf resorts elevate their marketing through cinematic aerial media, strategic course visuals, and premium branding content.</p>
            
            {}
            <div className="flex flex-wrap gap-6 pt-4">
              {trustIndicators.map((item, i) => <div key={i} data-index={i} className="flex items-center gap-2 text-sm font-medium text-foreground/80">
                  <item.icon className="w-5 h-5 text-primary" />
                  <span>{item.label}</span>
                </div>)}
            </div>
          </div>
          
          <div className="lg:w-1/2 relative group">
            <div className="absolute -inset-4 bg-primary/5 rounded-lg blur-xl group-hover:bg-primary/10 transition-all duration-500" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_course_aerial_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_course_aerial_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_course_aerial_hero.png-wvc-sizes" alt="Cinematic Golf Course Aerial" className="relative rounded-lg shadow-2xl w-full object-cover aspect-video" loading="lazy" />
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-32">
          {servicesData.map((service, index) => <div key={service.id} data-index={index} className="group relative p-8 bg-card border border-border/50 rounded-lg transition-all duration-500 hover:border-primary/50 hover:shadow-xl hover:-translate-y-2">
              <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-500">
                <service.icon size={32} strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-2xl font-bold mb-4 text-foreground">
                {service.title}
              </h3>
              <p className="font-sans text-muted-foreground leading-relaxed mb-6">
                {service.description}
              </p>
              
            </div>)}
        </div>

        {}
        

        {}
        <div className="relative rounded-lg overflow-hidden bg-primary/5 border border-primary/20 p-12 md:p-20 text-center">
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_texture_overlay.png)] opacity-5 pointer-events-none" />
          <div className="relative z-10 max-w-3xl mx-auto space-y-8">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground">
              Ready to Elevate Your Course?
            </h2>
            <p className="font-sans text-lg md:text-xl text-muted-foreground">
              Professional aerial media designed for golf courses, country clubs, and golf resorts.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
              <Button asChild size="lg" className="min-w-[200px] rounded-lg">
                <Link to="/RequestAQuotePage">Request a Quote</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="min-w-[200px] rounded-lg border-primary text-primary hover:bg-primary hover:text-primary-foreground">
                <Link to="/PackagesPage">View Packages</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}